import * as React from 'react';
import { MenuEntry } from '@europrocurement/flexy-components';
import {
    ROLE_API_FORMALITE_TYPEDOC_READ,
    ROLE_API_FORMALITE_TYPEDOC_CREATE,
    KeycloakRoute,
} from '@europrocurement/l2d-keycloak';
import DocumentTypesListing from './views/listing/DocumentTypesListing';
import DocumentTypeAdd from './views/add/DocumentTypeAdd';
import DocumentTypeRoot from './views/DocumentTypeRoot';
import DocumentTypeShow from './views/show/DocumentTypeShow';
import { DOCUMENT_TYPES_BASE_PATH, DOCUMENT_TYPE_LIST } from './constants/paths';

export const DocumentTypeRouter = {
    path: DOCUMENT_TYPES_BASE_PATH,
    element: <DocumentTypeRoot />,
    handle: { title: 'Types de documents' },
    children: [
        {
            path: 'liste',
            children: [
                {
                    path: '',
                    index: true,
                    element: (
                        <KeycloakRoute roles={[ROLE_API_FORMALITE_TYPEDOC_READ]}>
                            <DocumentTypesListing />
                        </KeycloakRoute>
                    ),
                },
                {
                    path: ':documentTypeId',
                    element: (
                        <KeycloakRoute roles={[ROLE_API_FORMALITE_TYPEDOC_READ]}>
                            <DocumentTypeShow />
                        </KeycloakRoute>
                    ),
                },
            ],
            handle: { title: 'Types de documents - Liste' },
        },
        {
            path: 'ajouter',
            element: (
                <KeycloakRoute roles={[ROLE_API_FORMALITE_TYPEDOC_CREATE]}>
                    <DocumentTypeAdd />
                </KeycloakRoute>
            ),
            handle: { title: 'Types de documents - Création' },
        },
    ],
};

const VALID_ROLES = [ROLE_API_FORMALITE_TYPEDOC_READ];

export const DocumentTypeMenuEntries: MenuEntry[] = [
    {
        title: 'Liste des types de documents',
        icon: 'file-lines',
        href: DOCUMENT_TYPE_LIST,
        role: VALID_ROLES,
    },
];
